const translations = {
    retentionNotice:
        'Generated by AcreConnect. Retain per applicable state recordkeeping requirements.'
};

export default translations;
